import { render, staticRenderFns } from "./ShippingEdit.vue?vue&type=template&id=2d9f308a"
import script from "./ShippingEdit.vue?vue&type=script&lang=js"
export * from "./ShippingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports